module.exports = __webpack_public_path__ + "img/clby-check.cb7fb2ba.jpg";